export { default as getCurrentModule } from './selectors/getCurrentModule';
export { initializeModule } from './actions/updateModule';
export { default as updateModule } from './actions/updateModule';
